<div class="flex flex-col gap-2">
  <div>
    <span>{{
      "Questo testo verrà sostituito con la firma smart" | transloco
    }}</span>
  </div>

  <dx-form
    [formData]="formData"
    (onFieldDataChanged)="onFieldDataChanged()"
    class="flex-1"
    [colCount]="2"
    [readOnly]="readonly"
  >
    <dxi-item
      dataField="align"
      editorType="dxSelectBox"
      [editorOptions]="{
        valueExpr: 'value',
        displayExpr: 'label',
        dataSource: [
          { value: 'left', label: 'Sinistra' | transloco },
          { value: 'center', label: 'Centro' | transloco },
          { value: 'right', label: 'Destra' | transloco }
        ]
      }"
      [label]="{
        text: 'Allinea' | transloco,
        location: 'top',
        visible: true,
        showColon: false
      }"
    ></dxi-item>
  </dx-form>
</div>
